import {EventEmitter, Injectable, Output} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Report} from '../../model/report';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class UserSuggestedReportsService {

  static readonly USER_GET_SUGGESTED_REPORTS_SERVICE_URL = environment.apiUrl.concat(environment.userGetSuggestedReportsServiceUrl);
  static readonly REPORT_ADD_TO_FAVOURITES_SERVICE_URL = environment.apiUrl.concat(environment.reportAddToFavourites);

  @Output() deactivateTopMenuActivePosition = new EventEmitter<boolean>();

  constructor(private httpClient : MasbitHttpService) { }

  getSuggestedReports(searchParams : any) : Observable<BackendServiceResponse<number, Array<Report>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Report>>>(
      UserSuggestedReportsService.USER_GET_SUGGESTED_REPORTS_SERVICE_URL, searchParams);
  }
  addToFavourites(reportId : number, userId : number) : Observable<BackendServiceResponse<number, string>> {
    return this.httpClient.post<BackendServiceResponse<number, string>>(UserSuggestedReportsService.REPORT_ADD_TO_FAVOURITES_SERVICE_URL,
      {userId : userId, reportId : reportId})
  }


}
